const e=async(e,t,n,r)=>{await e.put(`/apps/${t}/system-roles/${n}`,r)};export{e as updateSystemRole};
//# sourceMappingURL=update-system-role.mjs.map